import { render, staticRenderFns } from "./activityAdd.vue?vue&type=template&id=35fd3cf7"
import script from "./activityAdd.vue?vue&type=script&lang=js"
export * from "./activityAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35fd3cf7')) {
      api.createRecord('35fd3cf7', component.options)
    } else {
      api.reload('35fd3cf7', component.options)
    }
    module.hot.accept("./activityAdd.vue?vue&type=template&id=35fd3cf7", function () {
      api.rerender('35fd3cf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/tieTuNumber/activityAdd.vue"
export default component.exports